import { BrowserRouter, Routes, Route, Switch } from "react-router-dom";
import Inicio from './components/Inicio/Inicio';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Transparencia from './components/Transparencia/Transparencia';
import Rubros from './components/Rubros/Rubros';
import DetalleRubro from './components/DetalleRubro/DetalleRubro';
import RubrosHistoricos from "./components/RubrosHistoricos/RubrosHistoricos";
import Agenda from "./components/Agenda/Agenda";
import Error404 from "./components/Error404/Error404";
import Interes from "./components/Interes/Interes";
import Licitaciones from "./components/Licitaciones/Licitaciones";
import LicitacionesAnteriores from "./components/Licitaciones/LicitacionesAnteriores";
import Tramites from "./components/Tramites/Tramites";
import Mir from "./components/MIR/Mir";
import Organismos from "./components/Organismos/Organismos";
import Paaas from "./components/PAAAS/Paaas";
import RecursosFederales from "./components/RecursosFederales/RecursosFederales";
import ComiteEtica from "./components/ComiteEtica/ComiteEtica";
import Residencias from "./components/Residencias/Residencias";
import ProtocoloCero from "./components/ProtocoloCero/ProtocoloCero";
import Invitaciones from "./components/Invitaciones/Invitaciones";
import InvitacionesAnteriores from "./components/Invitaciones/InvitacionesAnteriores";
import RubrosHistoricos70 from "./components/RubrosHistoricos70/RubrosHistoricos70";
import Art70 from "./components/Art70/Art70";
import Funciones from "./components/Funciones/Funciones";
import ConstruyeTuCamino from "./components/ConstruyeTuCamino/ConstruyeTuCamino";
import CpappAnteriores from "./components/CPAPP/CpappAnteriores";
import AdjudicacionAnteriores from "./components/Adjudicacion/AdjudicacionAnteriores";
import Adjudicacion from "./components/Adjudicacion/Adjudicacion";
import PadronCTC from "./components/PadronCTC/PadronCTC";
import ReglamentoInterior from "./components/ReglamentoInterior/ReglamentoInterior";
import Reconstruccion2025 from "./components/Reconstruccion2025/Reconstruccion2025";
function App() {
  return (
    <BrowserRouter>
      <Header/>
        <Routes>
          <Route exact path="/" element={ <Inicio /> } />
          <Route exact path="/Transparencia" element={ <Transparencia/> } />
          <Route exact path="/Transparencia/Rubros" element={ <Rubros/> } />
          <Route exact path="/Transparencia/Rubros/DetalleRubro/:nombre" element={ <DetalleRubro/> } />
          <Route exact path="/Transparencia/Rubros/RubrosHistoricos" element={ <RubrosHistoricos/> } />
          <Route exact path="/Agenda" element={ <Agenda/> } />
          <Route exact path="*" element={<Error404 /> } />          
          <Route exact path="/Interes" element={ <Interes/> } />
          <Route exact path="/Licitaciones" element={ <Licitaciones/> } />
          <Route exact path="/Licitaciones/LicitacionesAnteriores/:ciclo" element={ <LicitacionesAnteriores/> } />
          <Route exact path="/Tramites" element={ <Tramites/> } />
          <Route exact path="/Mir" element={ <Mir/> } />    
          <Route exact path="/Organismos" element={ <Organismos/> } />
          <Route exact path="/Paaas" element={ <Paaas/> } />
          <Route exact path="/RecursosFederales" element={ <RecursosFederales/>} />
          <Route exact path="/ComiteEtica" element={ <ComiteEtica/>} />
          <Route exact path="/Residencias" element={ <Residencias/>} />
          <Route exact path="/ProtocoloCero" element={ <ProtocoloCero/>} />
          <Route exact path="/Invitaciones/Invitaciones" element={ <Invitaciones/> } />
          <Route exact path="/Invitaciones/InvitacionesAnteriores/:ciclo" element={ <InvitacionesAnteriores/> } />
          <Route exact path="/Art70" element={ <Art70/> } />
          <Route exact path="/RubrosHistoricos70" element={ <RubrosHistoricos70/> } />
          <Route exact path="/Funciones/Funciones" element={ <Funciones/> } />
          <Route exact path="/ConstruyeTuCamino" element={ <ConstruyeTuCamino/>}/>
          <Route exact path="/Adjudicacion/AdjudicacionAnteriores/:ciclo" element={ <AdjudicacionAnteriores/> } />
          <Route exact path="/Adjudicacion/Adjudicacion" element={ <Adjudicacion/> } />
          <Route exact path="/CPAPP/Cpapp/:ciclo" element={ <CpappAnteriores/> } />
          <Route exact path="/CPAPP/CpappAnteriores/:ciclo" element={ <CpappAnteriores/> } />
          <Route exact path="/PadronCTC" element={ <PadronCTC/> } />
          <Route exact path="/ReglamentoInterior" element={ <ReglamentoInterior/> } />
          <Route exact path="/Reconstruccion2025" element={ <Reconstruccion2025 /> } />
        </Routes>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
